import { formatText } from 'core/i18n';
import { getMainDocumentTypeByCountry } from 'utilities/multiLanguageHelper';
import {
    COUNTRY_DOCUMENT_TYPE_PN,
    COUNTRY_DOCUMENT_TYPE_DNI,
    COUNTRY_DOCUMENT_TYPE_NIE,
    COUNTRY_DOCUMENT_TYPE_PA,
    COUNTRY_DOCUMENT_TYPE_PP,
} from 'constants/multiLanguage';

export const getInformationMessage = (documentType, isCountrySelectedFromEuropeanUnion) => {
    const messagesByDocumentType = {
        [COUNTRY_DOCUMENT_TYPE_NIE]: isCountrySelectedFromEuropeanUnion
            ? formatText('personalDataSection-youWillNeedYourPassportAndCue')
            : formatText('personalDataSection-youWillNeedYourTie'),
        [getMainDocumentTypeByCountry()]: formatText('personalDataSection-youWillNeedYourDocument'),
        [COUNTRY_DOCUMENT_TYPE_PP]: formatText('personalDataSection-youWillNeedYourPassport'),
        [COUNTRY_DOCUMENT_TYPE_PN]: formatText('personalDataSection-youWillNeedYourPassport'),
        [COUNTRY_DOCUMENT_TYPE_PA]: formatText('personalDataSection-youWillNeedYourPassport'),
        [COUNTRY_DOCUMENT_TYPE_DNI]: formatText('personalDataSection-youWillNeedYourDNI'),
    };

    return messagesByDocumentType[documentType];
};
